import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import "./Header.css";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div className="logo">
          <span className="logo-text">Singularity</span>
          <span className="logo-innovations">Innovations</span>
        </div>

        <nav className={`nav-menu ${isMobileMenuOpen ? "mobile-open" : ""}`}>
          <button className="nav-link" onClick={() => scrollToSection("hero")}>Home</button>
          <button className="nav-link" onClick={() => scrollToSection("why-choose-us")}>Why Us</button>
          <button className="nav-link" onClick={() => scrollToSection("contact")}>Contact</button>
        </nav>

        <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
